import React, { Component } from 'react';
import { connect } from 'react-redux';
import FundraiserCard from 'src/ConnectedComponents/FundraiserCard';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import ContactUs from 'src/components/ContactUs';
import InfiniteScrollList from 'src/components/InfiniteScroll';
import {
	setLoadingState,
	setFinishedLoadingState,
	shouldLoad,
} from 'src/utils/infiniteScrollUtils';

import { getDonors } from 'src/redux/donors/donor.selector';
import { getTotal, getSkip } from 'src/redux/donors/donor.selector';

import styles from '../../index.css';
import { Box } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

const CONTACT_US = 'contactUs';
const MATCHED = 'matchedFundraiser';
const LIST = 'fundraiserList';

class FundraiserSetup extends Component {
	state = {};

	componentDidMount() {
		const foundMatch = this.props.matchedFundraiser !== undefined;
		const foundMore = this.props.fundraisers.length > 0;
		let page = CONTACT_US;

		if (foundMatch) {
			page = MATCHED;
		} else if (foundMore) {
			page = LIST;
		}

		this.setState({
			page,
			foundMatch,
			foundMore,
			hasShownList: !foundMatch && foundMore,
		});
	}

	showContactUs = () => {
		this.setState({ page: CONTACT_US });
	};

	showMatched = () => {
		this.setState({ page: MATCHED });
	};

	showList = () => {
		this.setState({ page: LIST, hasShownList: true });
	};

	returnToSelection = () => {
		if (this.state.hasShownList) {
			this.showList();
		} else {
			this.showMatched();
		}
	};

	leaveMatched = () => {
		if (this.state.foundMore) {
			this.showList();
		} else {
			this.showContactUs();
		}
	};

	loadFundraisers = () => {
		if (
			shouldLoad(
				this.state.loading,
				this.props.skip,
				this.props.total,
				this.props.fundraisers.length,
			)
		) {
			this.setState(setLoadingState, async () => {
				await this.props.fetchDonors({
					roles: 'fundraiser',
					$sort: { first: 1 },
					$skip: this.props.skip,
					$limit: 10,
				});

				this.setState(setFinishedLoadingState());
			});
		}
	};

	renderItem = fundraiser => (
		<Box marginBottom="4px" marginRight="2px" key={fundraiser._id}>
			<FundraiserCard fundraiser={fundraiser} />
		</Box>
	);

	render() {
		if (this.state.page === MATCHED) {
			return (
				<Box>
					<p>
						We found one fundraiser with your email. Click "That's me!" to confirm that
						it's you.
					</p>
					<FundraiserCard fundraiser={this.props.matchedFundraiser} />
					<RoundedRectangleButton
						className={styles.DefaultButton}
						fontSize="16px"
						marginTop="20px"
						onClick={this.leaveMatched}
					>
						That's not me
					</RoundedRectangleButton>
				</Box>
			);
		}

		if (this.state.page === LIST) {
			const welcomeText = this.state.foundMatch
				? "That wasn't you? That record matched the email you entered!"
				: "We couldn't find any fundraisers who matched your email exactly.";
			return (
				<Box>
					<p>{welcomeText}</p>
					<p>
						If you see yourself in this list, click "That's me!" to confirm your
						identity.
					</p>
					<Box borderTop={theme.boxBorderTop} borderLeft={theme.boxBorderLeft}>
						<InfiniteScrollList
							renderItem={this.renderItem}
							hasMore={this.props.total >= this.props.skip}
							loadFunction={this.loadFundraisers}
							data={this.props.fundraisers}
							showLoader={true}
							initialLoad={false}
							height={330}
						/>
					</Box>
					<RoundedRectangleButton
						className={styles.DefaultButton}
						fontSize="16px"
						marginTop="20px"
						onClick={this.showContactUs}
					>
						I'm not in this list
					</RoundedRectangleButton>
				</Box>
			);
		}

		// fall back to showing contact us
		const foundAny = this.state.foundMatch || this.state.foundMore;
		const errorMsg = foundAny
			? "Didn't see a user you expected to?"
			: "Uh oh! We couldn't find any fundraiser users in your data.";
		return (
			<Box>
				<ContactUs errorMsg={errorMsg} />
				{foundAny ? (
					<RoundedRectangleButton
						className={styles.DefaultButton}
						fontSize="16px"
						marginTop="20px"
						onClick={this.returnToSelection}
					>
						Back to selection
					</RoundedRectangleButton>
				) : null}
			</Box>
		);
	}
}

const mapStateToProps = state => ({
	// using donors to get the NXT link
	fundraisers: getDonors(state),
	total: getTotal(state),
	skip: getSkip(state),
});

export default FundraiserSetup = connect(mapStateToProps, {})(FundraiserSetup);



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/UserSetup/FundraiserSetup/index.js